import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/returns')({
  beforeLoad: ({ context, location }) => requireAuth({ context, location }),
  component: () => <Outlet />,
});
